import { Component } from '@angular/core';

@Component({
  selector: 'fastr-ui-login-view',
  templateUrl: './login-view.component.html',
  styleUrls: ['./login-view.component.scss'],
})
export class LoginViewComponent {}
